import React from 'react';
import { ChevronDown, Package, Truck } from 'lucide-react';
import { date, money } from '../api';
import { Status } from '../ui';

export const OrderHeader = ({ order, user, open, toggle }) => <button className="request-top"
  data-testid={`order-expand-${order.id}`} onClick={toggle} aria-expanded={open}>
  <span className="request-icon"><Package size={21} /></span>
  <span className="request-info"><strong>{order.number}</strong>
    <span>{user.role === 'supplier' ? order.buyer_company : order.supplier_name}</span></span>
  <span className="request-meta"><strong data-testid={`order-amount-${order.id}`}>{money(order.quote.total_paise)}</strong>
    <small>{date(order.created_at)}</small></span>
  <Status value={order.status} id={`order-status-${order.id}`} /><ChevronDown size={17} />
</button>;

export const OrderDetails = ({ order }) => <div className="order-details">
  <p data-testid={`po-reference-${order.id}`}><strong>Your PO reference:</strong> {order.po_number}</p>
  <p data-testid={`order-destination-${order.id}`}><strong>Delivery:</strong> {order.destination}, {order.pincode}</p>
  <p data-testid={`payment-status-${order.id}`}><strong>Payment:</strong> {order.payment_status}</p>
  {order.tracking && <p data-testid={`tracking-${order.id}`}><Truck size={15} /><strong>Carrier / tracking:</strong> {order.tracking}</p>}
</div>;